<template>
  <v-card align="center" justify="center" min-width="30vw" outlined>
    <v-card-title >
      <v-list-item>
        <v-list-item-title><h2><strong>{{ $t('allUserAssets') }}</strong></h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="overflow-y-auto px-5 py-7" style="max-height: 70vh !important;">
      <v-container fluid>
        <v-row v-for="asset in this.$store.state.user.assets" v-bind:key="asset.id" style="border-bottom: 1px solid #e3e3e3;" dense>
          <v-col class="d-flex align-center justify-start" cols="9">
            <h3 class="my-0 text-start" style="font-size: 14px; color: #111111">{{ truncateString(asset.ticker, 15) }}</h3>
            <p class="my-0 mx-2" style="font-size: 13px;">{{ truncateString(asset.assetName, 25) }}</p>
            <v-chip v-if="asset.market !== null" class="v-chip-custom" x-small><p class="my-0" style="font-size: 13px;">
              {{ asset.market.name }}</p>
            </v-chip>
          </v-col>
          <v-col class="d-flex align-center justify-end" cols="3">
            <v-icon class="icon delete-icon mr-2" small @click="deleteAsset(asset)">fa-regular fa-trash</v-icon>
          </v-col>
        </v-row>
      </v-container>
      <v-btn @click="close">{{ $t('close_SeeAllAssets') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SeeAllStrategies",
  methods: {
    removeAsset(asset) {
      this.$emit('removeAsset', asset);
    },
    truncateString(string, maxLength) {
      return (string !== null && string.length > maxLength) ? `${string.substring(0, maxLength)}...` : string;
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<style scoped>
  .v-chip-custom {
    background: var(--v-alternativeBtnBackground-base) !important;
  }

  .v-chip-custom .v-chip__content {
    color: var(--v-darkGrey-base) !important;
  }
</style>


